class Accordions {
  constructor() {
    const allAccordions = document.querySelectorAll(".accordion-item");

    allAccordions.forEach((item) => {
      item.getElementsByClassName("accordion-header")[0].addEventListener("click", (event) => {
        const header = event.currentTarget;

        // toggle arrow
        const image = header.getElementsByClassName("image-4")[0];
        image.classList.toggle("closed");

        // toggle body
        const body = header.nextElementSibling;
        body.classList.toggle("closed");
      });
    });
  }
}

export default Accordions;
